import Model, { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type PcsCardModel from './pcs-card.ts';

export default class PcsProgramModel extends Model {
  @attr declare description: string;
  @attr declare metadata: Record<string, unknown>;

  /*************************
   **  Relationships      **
   *************************/

  @hasMany('pcs-card', { async: false, inverse: 'pcsProgram' })
  declare pcsCards: PcsCardModel[];

  [Type] = 'pcs-program' as const;
}
